/*! @azure/msal-common v14.5.0 2023-12-01 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "14.5.0";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
